import { IDogeFields } from 'src/typings/global-config';

export interface IPlacement extends IDogeFields {
  [IPlacementFields.id]: string | number | Array<any> | object | null,
  [IPlacementFields.balconyArea]: string | number | Array<any> | object | null,
  [IPlacementFields.additionalCondition]: string | number | Array<any> | object | null,
  [IPlacementFields.bathrooms]: string | number | Array<any> | object | null,
  [IPlacementFields.bedrooms]: string | number | Array<any> | object | null,
  [IPlacementFields.complex]: string | number | Array<any> | object | null,
  [IPlacementFields.floors]: string | number | Array<any> | object | null,
  [IPlacementFields.house]: string | number | Array<any> | object | null,
  [IPlacementFields.livingArea]: string | number | Array<any> | object | null,
  [IPlacementFields.note]: string | number | Array<any> | object | null,
  [IPlacementFields.numeration]: string | number | Array<any> | object | null,
  [IPlacementFields.placementExplications]: string | number | Array<any> | object | null,
  [IPlacementFields.placementStatus]: string | number | Array<any> | object | null,
  [IPlacementFields.placementType]: string | number | Array<any> | object | null,
  [IPlacementFields.planningType]: string | number | Array<any> | object | null,
  [IPlacementFields.pricePerSqM]: string | number | Array<any> | object | null,
  [IPlacementFields.pricePerSqMAlternative]: string | number | Array<any> | object | null,
  [IPlacementFields.rooms]: string | number | Array<any> | object | null,
  [IPlacementFields.row0]: string | number | Array<any> | object | null,
  [IPlacementFields.row1]: string | number | Array<any> | object | null,
  [IPlacementFields.row2]: string | number | Array<any> | object | null,
  [IPlacementFields.row3]: string | number | Array<any> | object | null,
  [IPlacementFields.row4]: string | number | Array<any> | object | null,
  [IPlacementFields.row5]: string | number | Array<any> | object | null,
  [IPlacementFields.row6]: string | number | Array<any> | object | null,
  [IPlacementFields.row7]: string | number | Array<any> | object | null,
  [IPlacementFields.row8]: string | number | Array<any> | object | null,
  [IPlacementFields.row9]: string | number | Array<any> | object | null,
  [IPlacementFields.row0]: string | number | Array<any> | object | null,
  [IPlacementFields.section]: string | number | Array<any> | object | null,
  [IPlacementFields.tag]: string | number | Array<any> | object | null,
  [IPlacementFields.totalArea]: string | number | Array<any> | object | null,
  [IPlacementFields.totalPrice]: string | number | Array<any> | object | null,
  [IPlacementFields.totalPriceAlternative]: string | number | Array<any> | object | null,
  [IPlacementFields.urls]: {
    gallery: string[],
    pdfs: string[],
    [IPlacementFields.button4]: string,
    [IPlacementFields.button5]: string,
    [IPlacementFields.button6]: string,
  } | null,
  [IPlacementFields.variation]: string | number | Array<any> | object | null,
}

export enum IPlacementFields {
  id = 'id',
  balconyArea = 'balconyArea',
  additionalCondition = 'additionalCondition',
  bathrooms = 'bathrooms',
  bedrooms = 'bedrooms',
  complex = 'complex',
  floors = 'floors',
  house = 'house',
  livingArea = 'livingArea',
  note = 'note',
  numeration = 'numeration',
  placementExplications = 'placementExplications',
  placementStatus = 'placementStatus',
  placementType = 'placementType',
  planningType = 'planningType',
  pricePerSqM = 'pricePerSqM',
  pricePerSqMAlternative = 'pricePerSqMAlternative',
  rooms = 'rooms',
  row0 = 'row0',
  row1 = 'row1',
  row2 = 'row2',
  row3 = 'row3',
  row4 = 'row4',
  row5 = 'row5',
  row6 = 'row6',
  row7 = 'row7',
  row8 = 'row8',
  row9 = 'row9',
  section = 'section',
  tag = 'tag',
  totalArea = 'totalArea',
  totalPrice = 'totalPrice',
  totalPriceAlternative = 'totalPriceAlternative',
  urls = 'urls',
  button4 = 'app.button4',
  button5 = 'app.button5',
  button6 = 'app.button6',
  variation = 'variation',
}
